export const FakeService = [
  {
    id: "001",
    title: "Orthopedic Surgeon",
    description:
      "Lorem Ipsum is simply dummy text of the printings and typesetting industry",
    link: "Read More",
    img: "https://img.icons8.com/cotton/64/surgeon-skin-type-1.png",
  },
  {
    id: "002",
    title: "Dermatologist",
    description:
      "Get our text demo is simply dummy text of the printings and type and setting for content",
    link: "Read More",
    img: "https://img.icons8.com/external-flaticons-flat-flat-icons/64/external-dermatologist-skincare-flaticons-flat-flat-icons-2.png",
  },
  {
    id: "003",
    title: "Physical Therapist",
    description:
      "Lorem Ipsum is simply is very dummy text of the printings and type setting for content",
    link: "Read More",
    img: "https://img.icons8.com/color/48/physical-therapy.png",
  },
  {
    id: "004",
    title: "Cardiologist",
    description:
      "Lorem Ipsum is simply is very dummy text of the printings and type and setting for content",
    link: "Read More",
    img: "https://img.icons8.com/external-smashingstocks-flat-smashing-stocks/66/external-Cardiologist-medical-concepts-smashingstocks-flat-smashing-stocks.png",
  },
  {
    id: "005",
    title: "Oral Surgery",
    description:
      "Lorem Ipsum is simply is very dummy text of the printings and type and setting for content",
    link: "Read More",
    img: "https://raw.githubusercontent.com/saifulemon/images-for-all-project/main/Donto/Services/oral.svg",
  },
  {
    id: "006",
    title: "Neurologist",
    description:
      "Lorem Ipsum is simply is very dummy text of the printings and type setting for content",
    link: "Read More",
    img: "https://img.icons8.com/external-filled-outline-berkahicon/64/external-avatar-medical-worker-avatar-filled-outline-berkahicon-2.png",
  },
];
